export function clearLocalStorage() {

    const keepKeys = ['LOCALE_LANGUAGE'];

    Object.keys(localStorage).forEach((key) => {
        if (!keepKeys.includes(key)) {
            localStorage.removeItem(key);
        }
    });

}